import React from "react";
import CustomizedSnackbars from "./components/Snackbar";
import All from "./components/All";
import Loading from "./components/Loading";
import controls from "./components/controls";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import createFrecallTheme from "./components/FrecallTheme";


function App() {
  const getInitialMode = () => {
    const savedMode = localStorage.getItem("frecall-theme-mode");
    return savedMode === "dark" ? "dark" : "light";
  };

  const [themeMode, setThemeMode] = React.useState(getInitialMode);
  const theme = React.useMemo(() => createFrecallTheme(themeMode), [themeMode]);

  const toggleThemeMode = () => {
    setThemeMode((prevMode) => {
      const nextMode = prevMode === "light" ? "dark" : "light";
      localStorage.setItem("frecall-theme-mode", nextMode);
      return nextMode;
    });
  };

  let urlData = {};

  window.location.search.replaceAll("?","").split("&").forEach(element => {
    const elementList = element.split("=");
    urlData[elementList[0]] = elementList[1];
  })

  controls.channelName = urlData.agentName;
  controls.roomId = urlData.roomId; //sets the frecall Room ID.

  // console.log(controls.channelName)
  // console.log(controls.roomId)

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Loading />
      <CustomizedSnackbars/>
      <All themeMode={themeMode} toggleThemeMode={toggleThemeMode}/>
    </ThemeProvider>
  )
}

export default App;
